// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/angular-calendar.scss
// module id = 14
// module chunks = 0